import script from "./CatalogueList.vue?vue&type=script&setup=true&lang=js"
export * from "./CatalogueList.vue?vue&type=script&setup=true&lang=js"

import "./CatalogueList.vue?vue&type=style&index=0&id=9a149920&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9a149920"]])

export default __exports__